import { SendgridSuppressionGroup } from '@west-australian-newspapers/email-queue-message-types'
import React, { FC } from 'react'
import { PreferenceCard } from './PreferenceCard'
import {
    StyledPreferenceSection,
    StyledSectionHeader,
} from './PreferenceSection.styled'

export interface PreferenceSectionProps {
    section: EmailPreferenceSection
    isLoading: boolean
}

type SectionTitle =
    | 'Newsletters'
    | 'Subscriber Exclusive Newsletters'
    | 'Marketing & Promotions'

type SubscriptionFrequency = 'Daily' | 'Weekly' | 'Twice Daily' | 'Twice Weekly'

export interface EmailPreferenceItem {
    id?: SendgridSuppressionGroup //some new subscription still have no sendgrid id
    name: string
    description: string
    frequency?: SubscriptionFrequency
    subAccount: string
    guid?: string
    unSubId: number
    optIn?: boolean
}
export interface EmailPreferenceSection {
    sectionTitle: SectionTitle
    sectionItems: EmailPreferenceItem[]
}

export const PreferenceSection: FC<PreferenceSectionProps> = ({
    section,
    isLoading,
}) => {
    return (
        <div>
            <StyledSectionHeader>{section.sectionTitle}</StyledSectionHeader>
            <StyledPreferenceSection>
                {section.sectionItems.map((item, index) => (
                    <PreferenceCard
                        item={item}
                        key={index}
                        isLoading={isLoading}
                    />
                ))}
            </StyledPreferenceSection>
        </div>
    )
}
